export default "__VITE_ASSET__1jTVqi3X__"